jQuery(document).ready(function ($) {
	jQuery("select.quantity-range").on("change", function () {
		updatePrice();
	});

	jQuery("select.currencies").on("change", function () {
		updatePrice();
	});
});

function updatePrice() {
	const priceList = minerva_configurator_vars.pricelist;

    if ( 'object' == typeof priceList && jQuery('.tech-specs .quantity-range-price').length ) {
        var currentProductCode   = extractCode(getProductCode());
        var currentQuantityRange = jQuery('select.quantity-range').val();
        var currentCurrency      = jQuery('select.currencies').val();

        // Se "currentProductCode" è del tipo XXX-X e "priceList" contiene soltanto valori nel formato XXX devo modificare "currentProductCode".
        productCode = ( 'undefined' != typeof priceList['prices'][currentProductCode] ) ? currentProductCode : currentProductCode.substring(0, 3); 

        var currentPrice = priceList['prices'][productCode][currentCurrency][currentQuantityRange];

		jQuery(".tech-specs .quantity-range-price").text(currentPrice);

		const quantityRangePrices = jQuery(".cross-selling-section .quantity-range-price");

		quantityRangePrices.each(function (index, element) {
			let prices = jQuery(element).data(currentCurrency);

			if (prices) {
				let price = prices[currentQuantityRange];

                if (price) {
                    jQuery(element).text(price + " " + currentCurrency.toUpperCase());
                } else {
                    let firstKey = Object.keys(prices)[0];
                    let firstRange = jQuery('select.quantity-range option[value="' + firstKey + '"]').text();

                    price = prices[firstKey];

                    // jQuery(element).text(price + " " + currentCurrency.toUpperCase() + " " + "(" + firstRange + ")");
                    jQuery(element).text(price + " " + currentCurrency.toUpperCase());
                    jQuery(element).append(" <span>(" + firstRange + ")</span>");
                    // jQuery(element).append("<br><small>" + jQuery(element).data('moq') + "</small>");
                }
			}
		});
	}
}

function extractCode(str) {
	const match = str.match(/^([A-Z]{3}(?:-[A-Z])?)/);

	return match ? match[1] : null;
}
